/* Men's Rave Outfits. Shared behaviour for all mro-* sections.

   IMPORTANT: every mro-* section tags this file, so the browser executes it
   once per section on the page. Without the guard below each execution gets
   its own private modal and its own document listener, which stacks one modal
   per section and makes the close control look broken. Run once only.
*/
(function () {
  'use strict';

  if (window.__MRO_INIT__) return;
  window.__MRO_INIT__ = true;

  var CFG = window.MRO_CONFIG || {};
  var KLAVIYO_KEY = CFG.klaviyoKey || 'VGZRvJ';
  var ELIGIBLE_TYPES = (CFG.eligibleTypes || [
    't-shirt', 'tank top', 'hoodie', 'shorts', 'jogger',
    'hockey jersey', 'baseball jersey', 'basketball jersey', 'mesh jersey',
    'cross body bag', 'sling bag', 'pashmina', 'bucket hat'
  ]).map(function (s) { return String(s).toLowerCase(); });
  var TIERS = CFG.tiers || [{ qty: 2, off: 10 }, { qty: 3, off: 15 }, { qty: 4, off: 20 }];
  var TOP_TIER = TIERS[TIERS.length - 1];

  /* Tag on the cart events this file fires, so its own listener can ignore them. */
  var MRO_SOURCE = 'mro-fit';

  function track(name, payload) {
    payload = payload || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', name, payload); } catch (e) {}
    try {
      if (typeof fbq === 'function' && name === 'add_to_cart') {
        fbq('track', 'AddToCart', {
          content_name: payload.item_name, content_ids: [String(payload.item_id)],
          content_type: 'product', value: payload.value, currency: 'USD'
        });
      }
    } catch (e) {}
    try {
      if (typeof ttq !== 'undefined' && ttq && name === 'add_to_cart') {
        ttq.track('AddToCart', {
          content_id: String(payload.item_id), content_name: payload.item_name,
          value: payload.value, currency: 'USD'
        });
      }
    } catch (e) {}
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function tierFor(q) {
    var off = 0;
    for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i].qty) off = TIERS[i].off;
    return off;
  }
  function nextTier(q) {
    for (var i = 0; i < TIERS.length; i++) if (q < TIERS[i].qty) return TIERS[i];
    return null;
  }

  /* ---------------- pricing ---------------- */
  var lastPreview = 0;

  function paintPrices(off) {
    lastPreview = off;
    [].slice.call(document.querySelectorAll('[data-piece]')).forEach(function (card) {
      var el = card.querySelector('.mro-card-price');
      if (!el) return;
      var base = Math.round(parseFloat(card.getAttribute('data-product-price') || '0') * 100);
      if (!base) return;
      if (off > 0 && card.getAttribute('data-eligible') === '1') {
        var cut = Math.round(base * (1 - off / 100));
        el.innerHTML =
          '<span class="mro-now">' + money(cut) + '</span>' +
          '<s class="mro-was">' + money(base) + '</s>' +
          '<span class="mro-bsave">Bundle &amp; Save</span>';
        card.classList.add('is-discounted');
      } else {
        el.innerHTML = '<span class="mro-reg">' + money(base) + '</span>';
        card.classList.remove('is-discounted');
      }
    });
  }

  /* ---------------- modal ---------------- */
  var modal, modalTitle, modalBody, modalClose, lastFocus;
  var openedAt = 0;

  function buildModal() {
    if (modal) return;

    /* belt and braces: clear any modal a previous run may have left behind */
    var stale = document.querySelectorAll('.mro-modal');
    for (var i = 0; i < stale.length; i++) stale[i].parentNode.removeChild(stale[i]);

    modal = document.createElement('div');
    modal.className = 'mro-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="mro-modal-scrim" data-modal-close></div>' +
      '<div class="mro-modal-shell">' +
        '<button class="mro-modal-close" type="button" data-modal-close>Close</button>' +
        '<div class="mro-modal-box" role="dialog" aria-modal="true" aria-labelledby="mro-modal-title">' +
          '<h3 class="mro-modal-title" id="mro-modal-title"></h3>' +
          '<div class="mro-modal-body"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modalTitle = modal.querySelector('.mro-modal-title');
    modalBody = modal.querySelector('.mro-modal-body');
    modalClose = modal.querySelector('.mro-modal-close');

    modalClose.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      closeModal();
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-bis-email]')) {
        e.preventDefault();
        submitNotify();
      }
    });
  }

  function wireGallery() {
    var gal = modal.querySelector('[data-gal]');
    if (!gal) return;
    var dots = modal.querySelectorAll('[data-gal-dot]');
    if (!dots.length) return;
    var t;
    gal.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }, 60);
    }, { passive: true });
  }

  function showModal(title, html) {
    buildModal();
    lastFocus = document.activeElement;
    openedAt = Date.now();
    modalTitle.textContent = title || '';
    modalBody.innerHTML = html;
    modalBody.querySelectorAll('.mro-acc-item').forEach(function (item) {
      item.classList.remove('is-open');
      var h = item.querySelector('[data-acc-head]');
      if (h) h.setAttribute('aria-expanded', 'false');
    });
    wireGallery();
    modal.removeAttribute('hidden');
    document.body.classList.add('mro-locked');
    requestAnimationFrame(function () { modal.classList.add('is-on'); });
  }

  function isOpen() { return modal && !modal.hasAttribute('hidden'); }

  function closeModal() {
    if (!isOpen()) return;
    modal.classList.remove('is-on');
    document.body.classList.remove('mro-locked');
    setTimeout(function () {
      modal.setAttribute('hidden', '');
      modalBody.innerHTML = '';
    }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ---------------- back in stock ---------------- */
  var pendingVariant = null, pendingTitle = '';

  function openNotify(card) {
    var select = card.querySelector('[data-variant-select]');
    pendingVariant = select ? select.value : null;
    pendingTitle = card.getAttribute('data-product-title') || '';
    var sizeLabel = '';
    if (select && select.tagName === 'SELECT' && select.selectedIndex > -1) {
      sizeLabel = select.options[select.selectedIndex].text;
    }
    showModal(pendingTitle,
      '<p class="mro-bis-lead">This one is out of stock' +
        (sizeLabel ? ' in <strong>' + sizeLabel + '</strong>' : '') +
        '. Drop your email and we will let you know the moment it is back.</p>' +
      '<div class="mro-bis-row">' +
        '<input class="mro-bis-input" type="email" inputmode="email" autocomplete="email" ' +
               'placeholder="you@email.com" aria-label="Email address" data-bis-email>' +
        '<button class="mro-bis-btn" type="button" data-bis-send>Notify me</button>' +
      '</div>' +
      '<p class="mro-bis-msg" data-bis-msg role="status"></p>' +
      '<p class="mro-bis-fine">One email about this item. We will not add you to anything else.</p>');
    track('notify_me_opened', { item_name: pendingTitle });
  }

  function submitNotify() {
    var input = modal.querySelector('[data-bis-email]');
    var msg = modal.querySelector('[data-bis-msg]');
    var btn = modal.querySelector('[data-bis-send]');
    if (!input || !msg || !btn) return;

    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      msg.textContent = 'Enter a valid email address.';
      msg.className = 'mro-bis-msg is-bad';
      input.focus();
      return;
    }
    if (!KLAVIYO_KEY || !pendingVariant) {
      msg.textContent = 'Could not set that up. Please use the product page.';
      msg.className = 'mro-bis-msg is-bad';
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Sending...';
    msg.textContent = '';
    msg.className = 'mro-bis-msg';

    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'a=' + encodeURIComponent(KLAVIYO_KEY) +
            '&email=' + encodeURIComponent(email) +
            '&variant=' + encodeURIComponent(pendingVariant) +
            '&platform=shopify'
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        if (data && data.success) {
          msg.textContent = 'You are on the list. We will email you when it lands.';
          msg.className = 'mro-bis-msg is-good';
          input.disabled = true;
          btn.textContent = 'Done';
          track('notify_me_signup', { item_name: pendingTitle, item_id: pendingVariant });
        } else {
          var err = 'Something went wrong. Try the product page instead.';
          if (data && data.errors && data.errors.length) err = String(data.errors[0]);
          msg.textContent = err;
          msg.className = 'mro-bis-msg is-bad';
          btn.disabled = false;
          btn.textContent = 'Notify me';
        }
      })
      .catch(function () {
        msg.textContent = 'Could not reach the server. Try again in a moment.';
        msg.className = 'mro-bis-msg is-bad';
        btn.disabled = false;
        btn.textContent = 'Notify me';
      });
  }

  /* ---------------- bundle bar ----------------
     Concept A1 "hairline". Three parts: a lime status for what is already
     active, a grey running total of what that is worth, and the next step.
     The whole bar is one button that opens the cart drawer. */
  var bar, barIn, barFill, barStatus, barSaved, barMsg, lastEarned = -1;

  function buildBar() {
    if (bar) return;
    var staleBars = document.querySelectorAll('.mro-bar');
    for (var i = 0; i < staleBars.length; i++) staleBars[i].parentNode.removeChild(staleBars[i]);

    bar = document.createElement('div');
    bar.className = 'mro-bar';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML =
      '<button class="mro-bar-in" type="button" data-bar-cart>' +
        '<span class="mro-bar-rail"><i class="mro-bar-fill"></i></span>' +
        '<span class="mro-bar-txt">' +
          '<span class="mro-bar-top">' +
            '<span class="mro-bar-status"></span>' +
            '<span class="mro-bar-saved"></span>' +
          '</span>' +
          '<span class="mro-bar-msg"></span>' +
        '</span>' +
        '<span class="mro-bar-chev" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" focusable="false">' +
            '<path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="3" ' +
                  'stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
      '</button>';
    document.body.appendChild(bar);
    barIn = bar.querySelector('.mro-bar-in');
    barFill = bar.querySelector('.mro-bar-fill');
    barStatus = bar.querySelector('.mro-bar-status');
    barSaved = bar.querySelector('.mro-bar-saved');
    barMsg = bar.querySelector('.mro-bar-msg');
  }

  function isEligible(item) {
    return ELIGIBLE_TYPES.indexOf((item.product_type || '').toLowerCase()) !== -1;
  }

  /* Progress is measured per TIER, not per piece. Straight qty/4 would squeeze
     the 15% to 20% leg into the last sliver of the rail even though it is one
     piece away, same as every other leg. */
  function ladderFill(q) {
    var stops = [0], i;
    for (i = 0; i < TIERS.length; i++) stops.push(TIERS[i].qty);
    for (i = 1; i < stops.length; i++) {
      if (q < stops[i]) {
        var span = stops[i] - stops[i - 1];
        return ((i - 1) + (q - stops[i - 1]) / span) / TIERS.length * 100;
      }
    }
    return 100;
  }

  function render(qty, cents) {
    buildBar();
    var earned = tierFor(qty);
    var preview = tierFor(qty + 1);
    var nxt = nextTier(qty);

    paintPrices(preview);
    barFill.style.width = ladderFill(qty) + '%';

    /* Status: what is already switched on. With nothing earned yet, advertise
       the ceiling rather than announcing an absence. CSS uppercases it. */
    barStatus.textContent = earned > 0
      ? earned + '% off activated'
      : 'Save up to ' + TOP_TIER.off + '%';

    /* Running total, in grey beside the status. Empty until there is a real
       number to show, and :empty hides it so no stray gap opens up. */
    barSaved.textContent = earned > 0
      ? money(Math.round(cents * earned / 100)) + ' saved'
      : '';

    if (nxt) {
      var need = nxt.qty - qty;
      /* An empty cart reads "Add 2 pieces", not "Add 2 more". */
      var lead = qty === 0 ? 'Add ' + nxt.qty + ' pieces' : 'Add ' + need + ' more';
      barMsg.innerHTML = lead + ' to save <span>' + nxt.off + '%</span>';
    } else {
      /* Top tier: the status already says 20%, so repeating it here would say
         the same thing twice. Point at the only thing left to do. Tapping the
         bar opens the cart drawer. */
      barMsg.textContent = 'View Cart';
    }
    bar.classList.toggle('is-max', !nxt && qty > 0);

    barIn.setAttribute('aria-label',
      'Open cart. ' + barStatus.textContent +
      (barSaved.textContent ? ', ' + barSaved.textContent : '') +
      '. ' + barMsg.textContent);

    bar.classList.toggle('is-on', qty > 0 || window.scrollY > 500);

    if (earned > lastEarned && lastEarned >= 0) {
      bar.classList.add('is-pop');
      setTimeout(function () { bar.classList.remove('is-pop'); }, 700);
      track('bundle_tier_reached', { tier_percent: earned, eligible_items: qty });
    }
    lastEarned = earned;
  }

  /* The theme's cart drawer is a custom element with an open() method
     (assets/cart-drawer.js). Fall back to the cart page only if the drawer is
     switched off in theme settings, so this never dead ends. */
  function openCart() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      track('bundle_bar_cart_opened', {});
      return;
    }
    window.location.href = '/cart';
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = 0, cents = 0;
        (cart.items || []).forEach(function (item) {
          if (isEligible(item)) {
            qty += item.quantity;
            cents += (item.final_line_price != null ? item.final_line_price : item.line_price);
          }
        });
        render(qty, cents);
        return cart;
      })
      .catch(function () {});
  }

  /* Tell the rest of the theme the cart moved.

     The header cart bubble, the cart drawer and the cart line items all learn
     about a change from ONE thing: a 'cart:update' event on document. See
     assets/events.js, cart-icon.js and component-cart-items.js. Posting
     straight to /cart/add.js the way the Add buttons here do is invisible to
     every one of them, which is why the bubble kept its old number and the
     drawer kept its old contents until the page was reloaded.

     itemCount has to be the ABSOLUTE cart count. cart-icon.js only treats it
     as a delta to add on when data.source is 'product-form-component'.
     Passing no sections makes cart-items re-render itself, which is what we
     want, since this file has no section HTML to hand it. */
  function announceCart(cart) {
    if (!cart) return cart;
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: MRO_SOURCE,
        data: { source: MRO_SOURCE, itemCount: cart.item_count }
      }
    }));
    return cart;
  }

  /* ---------------- UV sliders ----------------
     Handles an image pair or a video pair. With video the two clips are kept
     roughly in step, so the wipe compares the same moment of each take. */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-uv-slider]').forEach(function (wrap) {
      if (wrap._mroReady) return;
      wrap._mroReady = true;

      var frame = wrap.querySelector('.mro-uv-frame');
      var clip = wrap.querySelector('[data-uv-clip]');
      var handle = wrap.querySelector('[data-uv-handle]');
      var range = wrap.querySelector('[data-uv-range]');
      if (!frame || !clip || !handle || !range) return;

      var vids = wrap.querySelectorAll('[data-uv-video]');
      if (vids.length === 2) {
        var vA = vids[0], vB = vids[1];
        vA.addEventListener('timeupdate', function () {
          if (Math.abs(vA.currentTime - vB.currentTime) > 0.25) {
            try { vB.currentTime = vA.currentTime; } catch (err) {}
          }
        });
        [vA, vB].forEach(function (v) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
      }

      var used = false;
      function paint(p) {
        p = Math.max(0, Math.min(100, p));
        clip.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        handle.style.left = p + '%';
      }
      function flagUse() {
        if (used) return;
        used = true;
        var fit = wrap.closest('[data-fit]');
        track('uv_slider_used', { fit_name: fit ? fit.getAttribute('data-fit') : '' });
      }
      function fromPointer(x) {
        var b = frame.getBoundingClientRect();
        if (!b.width) return;
        range.value = String(Math.round(((x - b.left) / b.width) * 100));
        paint(parseFloat(range.value));
        flagUse();
      }
      range.addEventListener('input', function () { paint(parseFloat(range.value)); flagUse(); });
      range.addEventListener('focus', function () { wrap.classList.add('is-drag'); });
      range.addEventListener('blur', function () { wrap.classList.remove('is-drag'); });

      var dragging = false;
      frame.addEventListener('pointerdown', function (e) {
        dragging = true;
        wrap.classList.add('is-drag');
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
        fromPointer(e.clientX);
      });
      frame.addEventListener('pointermove', function (e) { if (dragging) fromPointer(e.clientX); });
      function stop(e) {
        dragging = false;
        wrap.classList.remove('is-drag');
        try { frame.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      frame.addEventListener('pointerup', stop);
      frame.addEventListener('pointercancel', stop);
      paint(50);
    });
  }

  /* ---------------- fit guide accordion ----------------
     Collapsing is max-height only. The copy and its links stay in the DOM the
     whole time so crawlers still see them while the panel is shut. */
  function setGuide(guide, panel, open) {
    var peek = panel.style.getPropertyValue('--mro-guide-peek') || '110px';
    if (open) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      guide.classList.add('is-open');
      var done = function () {
        panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
      setTimeout(done, 500);
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      guide.classList.remove('is-open');
      panel.style.maxHeight = peek;
    }
  }

  /* ---------------- toast ---------------- */
  var toast;
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mro-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  /* ---------------- one delegated click listener ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (isOpen() && modal.contains(t)) {
      if (Date.now() - openedAt < 400) { e.preventDefault(); return; }

      if (t.closest('[data-modal-close]')) { e.preventDefault(); closeModal(); return; }
      if (t.closest('[data-bis-send]')) { e.preventDefault(); submitNotify(); return; }

      var prev = t.closest('[data-gal-prev]');
      var next = t.closest('[data-gal-next]');
      if (prev || next) {
        e.preventDefault();
        var gal = modal.querySelector('[data-gal]');
        if (gal) gal.scrollBy({ left: next ? gal.clientWidth : -gal.clientWidth, behavior: 'smooth' });
        return;
      }

      var head = t.closest('[data-acc-head]');
      if (head) {
        e.preventDefault();
        var item = head.parentNode;
        var group = head.closest('[data-acc-group]');
        if (!group) return;
        var wasOpen = item.classList.contains('is-open');
        group.querySelectorAll('.mro-acc-item').forEach(function (sib) {
          sib.classList.remove('is-open');
          var h = sib.querySelector('[data-acc-head]');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      return;
    }

    if (t.closest('[data-bar-cart]')) {
      e.preventDefault();
      openCart();
      return;
    }

    var guideBtn = t.closest('[data-guide-toggle]');
    if (guideBtn) {
      e.preventDefault();
      var guide = guideBtn.closest('[data-guide]');
      if (!guide) return;
      var panel = guide.querySelector('[data-guide-panel]');
      if (!panel) return;
      var willOpen = !guide.classList.contains('is-open');
      setGuide(guide, panel, willOpen);
      guideBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      var txt = guideBtn.querySelector('.mro-guide-btn-txt');
      if (txt) {
        txt.textContent = willOpen
          ? (guideBtn.getAttribute('data-less') || 'Read less')
          : (guideBtn.getAttribute('data-more') || 'Read more');
      }
      if (!willOpen) {
        var top = guide.getBoundingClientRect().top;
        if (top < 0) guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      track('fit_guide_toggled', { state: willOpen ? 'open' : 'closed' });
      return;
    }

    var uvBtn = t.closest('[data-uv-toggle]');
    if (uvBtn) {
      e.preventDefault();
      var uvCard = uvBtn.closest('.mro-card');
      if (!uvCard) return;
      var lit = uvCard.classList.toggle('is-lit');
      uvBtn.setAttribute('aria-pressed', lit ? 'true' : 'false');
      if (lit) track('card_flipped', { item_name: uvCard.getAttribute('data-product-title') || '' });
      return;
    }

    var notifyBtn = t.closest('[data-notify]');
    if (notifyBtn) {
      e.preventDefault();
      var nCard = notifyBtn.closest('.mro-card');
      if (nCard) openNotify(nCard);
      return;
    }

    var specBtn = t.closest('[data-spec-toggle]');
    if (specBtn) {
      e.preventDefault();
      var specCard = specBtn.closest('.mro-card');
      if (!specCard) return;
      var panelSpec = specCard.querySelector('[data-spec]');
      if (!panelSpec) return;
      showModal(specCard.getAttribute('data-product-title') || '', panelSpec.innerHTML);
      track('view_item_specs', { item_name: specCard.getAttribute('data-product-title') || '' });
      return;
    }

    var addBtn = t.closest('[data-add]');
    if (!addBtn || addBtn.disabled) return;
    e.preventDefault();
    var card = addBtn.closest('[data-piece]');
    if (!card) return;
    var select = card.querySelector('[data-variant-select]');
    var variantId = select ? select.value : null;
    if (!variantId) return;

    var title = card.getAttribute('data-product-title') || '';
    var price = parseFloat(card.getAttribute('data-product-price') || '0');
    var type = card.getAttribute('data-product-type') || '';
    var original = addBtn.textContent;

    addBtn.disabled = true;
    addBtn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        addBtn.textContent = 'Added';
        addBtn.classList.add('is-added');
        showToast(title + ' added');
        track('add_to_cart', {
          item_id: variantId, item_name: title, item_category: type,
          value: price, currency: 'USD'
        });
        return refreshCart();
      })
      .then(function (cart) {
        announceCart(cart);
        setTimeout(function () {
          addBtn.textContent = original;
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        addBtn.textContent = 'Retry';
        showToast('Could not add that one. Try again.');
        setTimeout(function () {
          addBtn.textContent = original;
          addBtn.disabled = false;
        }, 2000);
      });
  });

  /* ---------------- impressions + scroll ---------------- */
  function watchFits(scope) {
    if (!('IntersectionObserver' in window)) return;
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        seen.unobserve(en.target);
        track('view_fit', { fit_name: en.target.getAttribute('data-fit') });
      });
    }, { threshold: 0.3 });
    (scope || document).querySelectorAll('[data-fit]').forEach(function (el) {
      if (el._mroSeen) return;
      el._mroSeen = true;
      seen.observe(el);
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      if (bar) bar.classList.toggle('is-on', window.scrollY > 500 || lastEarned > 0);
      ticking = false;
    });
  }, { passive: true });

  /* ---------------- boot ---------------- */
  function boot(scope) {
    initSliders(scope);
    watchFits(scope);
    paintPrices(lastPreview);
  }

  function start() {
    boot(document);
    refreshCart();
    track('view_mens_rave_lp', { page: 'los-mro' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    refreshCart();
  });
  document.addEventListener('shopify:section:unload', function () { refreshCart(); });

  /* Skip the events this file fired itself, or announceCart would loop. */
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.sourceId === MRO_SOURCE) return;
    refreshCart();
  });

  window.MRO = {
    refresh: refreshCart, boot: boot, close: closeModal,
    announce: announceCart, openCart: openCart
  };
})();